module.exports = __webpack_public_path__ + "img/2012-02_bloomberg.2b732543.jpg";